import React from "react";
import { useAppSettings } from "../../../../hooks/useAppSettings.tsx";
import Layout from "../../../Layout.tsx";
import Title from "../../../Title.tsx";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/index.ts";
import { notification } from "../../../../utils/Notifications.tsx";
import { useParams } from "react-router-dom";
import {
  setLoading,
  setRecords,
  setTotal,
} from "../../../../store/slices/inasistenciasSlice.ts";
import { findNotAssistance } from "../../../../services/branchSchedule.service.ts";
import FilterIniasistencias from "./FilterIniasistencias.tsx";
import PaginationInasistencias from "./PaginationInasistencias.tsx";
import TableInasistencias from "./TableInasistencias.tsx";

const Inasistencias = () => {
  useAppSettings();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { page, limit, param, fetch, query } = useSelector(
    (state: RootState) => state.inasistencias
  );

  React.useEffect(() => {
    fetchDependencies();
  }, [page, limit, param, fetch, query]);

  const fetchDependencies = async () => {
    console.log("fetchDependencies");
    dispatch(setLoading(true));
    try {
      const offset = page === 0 ? 0 : page * limit;
      let queryToSend =
        query +
        `&limit=${limit}&offset=${offset}${id ? `&checkBranch=${id}` : ""}`;
      if (queryToSend.length === 0) {
        queryToSend = "type=all";
      }
      const response = await findNotAssistance(queryToSend);
      console.log(response);
      dispatch(setRecords(response.records));
      dispatch(setTotal(response.total));
    } catch (error) {
      notification("Error", error.message, "danger");
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Layout>
      <Title
        baseTitle="Sucursales"
        basePath="/sucursales"
        activeTitle="Tabla de Inasistencias"
        title="Resumen de Inasistencias"
      />
      <div className="tab-pane fade active show" id="Puestos">
        <div className="card border-0 m-4">
          <div className="tab-content p-3">
            <FilterIniasistencias id={id} />
            <TableInasistencias />
            <PaginationInasistencias />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Inasistencias;
